import { storableError } from '../../util/errors';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { post } from '../../util/api';

// ================ Action types ================ //

const CLAIM_DISCOUNT_REQUEST = 'app/PartnerLandingPage/CLAIM_DISCOUNT_REQUEST';
const CLAIM_DISCOUNT_SUCCESS = 'app/PartnerLandingPage/CLAIM_DISCOUNT_SUCCESS';
const CLAIM_DISCOUNT_ERROR = 'app/PartnerLandingPage/CLAIM_DISCOUNT_ERROR';
const CLAIM_DISCOUNT_RESET = 'app/PartnerLandingPage/CLAIM_DISCOUNT_RESET';

// ================ Reducer ================ //

const initialState = {
  claimInProgress: false,
  claimError: null,
  claimSuccess: null,
};

export default function partnerLandingPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case CLAIM_DISCOUNT_REQUEST:
      return { ...state, claimInProgress: true, claimError: null, claimSuccess: null };
    case CLAIM_DISCOUNT_SUCCESS:
      return { ...state, claimInProgress: false, claimSuccess: payload };
    case CLAIM_DISCOUNT_ERROR:
      return { ...state, claimInProgress: false, claimError: payload };
    case CLAIM_DISCOUNT_RESET:
      return { ...state, claimError: null, claimSuccess: null };
    default:
      return state;
  }
}

// ================ Thunks ================ //

export const claimPartnerDiscount = code => dispatch => {
  dispatch({ type: CLAIM_DISCOUNT_REQUEST });

  return post('/api/store-partner-discount', { voucherCode: code })
    .then(response => {
      dispatch({ type: CLAIM_DISCOUNT_SUCCESS, payload: response });
      dispatch(fetchCurrentUser());
      return response;
    })
    .catch(e => {
      dispatch({
        type: CLAIM_DISCOUNT_ERROR,
        payload: { ...storableError(e), code: e.error || null },
      });
      throw e;
    });
};

export const resetClaim = () => ({ type: CLAIM_DISCOUNT_RESET });

export const loadData = () => dispatch => {
  return dispatch(fetchCurrentUser());
};
